import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const userDataString = localStorage.getItem(window.APPSETTING.appname + "user");
  
  // 1. Check if the key exists
  if (!userDataString) {
    return <Navigate to="/login" replace />;
  }

  try {
    const authData = JSON.parse(userDataString);
    
    // 2. Check if success is true and token exists
    if (!authData.success || !authData.user?.token) {
      return <Navigate to="/login" replace />;
    }

    return <Outlet />; // Access granted
  } catch (e) {
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;